import { useMemo } from 'react';
import useContentControls, { useContentControlsLoaded } from './useContentControls';

// Editorial Studio — flags FAIL-CLOSED (ES1.e), calqué sur useSocialFlags.
// Lit content_controls.features.editorial_studio.* : clé absente = OFF,
// booléen vrai uniquement si littéralement true (miroir de flags.py backend).

const DEFAULT_FLAGS = {
  enabled: false,
  adminPreviewEnabled: false,
  loaded: false, // anti-race : ne jamais rediriger tant que false
};

export default function useEditorialStudioFlags() {
  const cc = useContentControls();
  const loaded = useContentControlsLoaded();

  return useMemo(() => {
    const cfg = cc && cc.features && typeof cc.features === 'object'
      ? cc.features.editorial_studio
      : null;
    if (!cfg || typeof cfg !== 'object') {
      return { ...DEFAULT_FLAGS, loaded };
    }
    return {
      enabled: cfg.enabled === true,
      adminPreviewEnabled: cfg.admin_preview_enabled === true,
      loaded,
    };
  }, [cc, loaded]);
}

// Visibilité de la surface Studio pour un utilisateur donné — MIROIR de la
// gate backend (routes.py) : module ouvert, OU preview réservé aux admins.
// Le rôle editor est ensuite exigé par le backend (403) : la garde de route
// ne redirige que sur l'invisibilité, jamais sur le rôle.
export function isStudioVisibleForUser(flags, isAdmin) {
  if (!flags) return false;
  if (flags.enabled) return true;
  return flags.adminPreviewEnabled && isAdmin === true;
}
